<template>
<div>
    <span v-if="validation" style="color: red; font-size: 20px; padding-right: 3px;">*</span>
	<span style="font-size:14px; font-family:Microsoft YaHei; font-weight:bold; color:rgba(51,51,51,1);">{{lable}}：</span>
	<VsSelect 
		style="display: inline-block;background:rgba(255,255,255,1);border-radius:3px;"
		:lablewidth="lablewidth" 
		:width="width" 
		:lablecolor="lablecolor"
		:classtype="classtype"
		v-model="modval"
		:loopdata="droplist"
		:keys="['name']"
		@input="fnInputAct"
		@on-enter="fnEnterpressAct"
		@on-confirm="fnSelectConfirm">
	</VsSelect>
</div>
</template>

<script>
	export default{
		props:{
			value:{},
			loopdata:{},
			keys:{},
			lablewidth:{},
			width:{},
			lable:{},
			classtype:{},
			returnkey:{},
			lablecolor:{},
			validation:{},
		},
		model: {
			prop: 'value',
			event: 'on-select'
		},
		data(){
			return{
                modval: this.value,
                droplist:[
                {
                    name:'自动价'
                },{
                    name:'批发价'
                },{
                    name:'零售价'
                },{
                    name:'会员价'
                },{
                    name:'特价1'
                },{
                    name:'特价2'
                },{
                    name:'特价3'
                },{
                    name:'特价4'
                },{
                    name:'特价5'
                },{
                    name:'特价6'
                }]
			}
		},
		methods:{
			fnInputAct(){
				this.fnSelectConfirm()
			},
			fnSelectConfirm(data){
				if(data){
					if(this.returnkey){
						this.$emit('on-select', data[this.returnkey])
					}else{
						this.$emit('on-select',data)
					}
				}else{
					this.$emit('on-select',"")
				}
			},
			fnEnterpressAct($event){
				this.$emit('on-enter',$event)
			}
		}
	}
</script>